<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="120px" style="margin-top: 20px">
    <el-form-item label="权限">
      <el-select :popper-append-to-body="false" popper-class="form-select-dropdown" v-model="form.job" class="form-select" placeholder="请选择">
        <el-option
          label="网格员"
          value="网格员">
        </el-option>
        <el-option
          label="巡查员"
          value="巡查员">
        </el-option>
        <el-option
          label="管理员"
          value="管理员">
        </el-option>
        <el-option
          label="一般人员"
          value="一般人员">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="姓名" prop="name">
      <el-input class="form-input" v-model="form.name" placeholder="请输入"></el-input>
    </el-form-item>
    <el-form-item label="手机号/账号" prop="tel">
      <el-input class="form-input" v-model="form.tel" placeholder="请输入"></el-input>
    </el-form-item>
    <el-form-item label="负责区域">
      <el-select :popper-append-to-body="false" popper-class="form-select-dropdown" v-model="form.areaId" class="form-select" placeholder="请选择">
        <el-option
          v-for="item in townshipList"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="村镇名称">
      <el-input v-model="form.remark" class="form-input"  placeholder="请输入"></el-input>
    </el-form-item>
    <div class="foot">
      <div class="cancel" @click="cancel">取消</div>
      <div class="confirm" @click="confirm">确定</div>
    </div>
  </el-form>
</template>

<script>
import { townshipList } from "../../../../utils/common";

export default {
  name: "AddEidt",
  props: {
    info: { type: Object, default: () => {} }
  },
  data () {
    return {
      townshipList: townshipList,
      form: {
        job: '',
        tel: '',
        areaId: '',
        authUseSys: 'pc', // 'pc'=>'大屏(客户端)'，'weapp'=>'小程序'， 可以登录多个，用逗号隔开
        remark: '' // 备注（安次火点上用来记录村镇名称）
      },
      rules: {
        name: { required: true, message: '请输入姓名', trigger: 'blur' },
        tel: { required: true, message: '请输入电话号码', trigger: 'blur' }
      }
    }
  },
  mounted() {
    this.form = JSON.parse(JSON.stringify(this.info))
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    confirm () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.form)
          this.$emit('close')
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped lang="less">
  .form-input,.form-select{
    width: 420px;
    height: 40px;
  }
  .foot{
    display: flex;
    width: 100%;
    justify-content: center;
    div{
      cursor: pointer;
      width: 200px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      font-size: 22px;
      background-size: 100% 100%;
    }
    .cancel{
      background-image: url("~@/assets/img/box2.png");
      color: #00FFF6;
    }
    .confirm{
      background-image: url("~@/assets/img/box4.png");
      color: #00B2FF;
    }
  }
</style>
